// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ExternalImportProgress,
  ExternalImportProgressFromJSON,
  ExternalImportProgressToJSON,
  ExternalImportStats,
  ExternalImportStatsFromJSON,
  ExternalImportStatsToJSON,
  ExternalImportThrottle,
  ExternalImportThrottleFromJSON,
  ExternalImportThrottleToJSON,
} from "./";

/**
 *
 * @export
 * @interface ExternalImportStatus
 */
export interface ExternalImportStatus {
  /**
   *
   * @type {number}
   * @memberof ExternalImportStatus
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof ExternalImportStatus
   */
  importType: string;
  /**
   * Destination TestCollab project ID
   * @type {number}
   * @memberof ExternalImportStatus
   */
  projectId?: number;
  /**
   * Source-system project key
   * @type {string}
   * @memberof ExternalImportStatus
   */
  sourceProject?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalImportStatus
   */
  status: ExternalImportStatusStatusEnum;
  /**
   * Human-readable label for the current step
   * @type {string}
   * @memberof ExternalImportStatus
   */
  stage?: string;
  /**
   *
   * @type {ExternalImportProgress}
   * @memberof ExternalImportStatus
   */
  progress?: ExternalImportProgress;
  /**
   *
   * @type {ExternalImportStats}
   * @memberof ExternalImportStatus
   */
  stats?: ExternalImportStats;
  /**
   *
   * @type {ExternalImportThrottle}
   * @memberof ExternalImportStatus
   */
  throttle?: ExternalImportThrottle;
  /**
   *
   * @type {string}
   * @memberof ExternalImportStatus
   */
  lastActivity?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalImportStatus
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalImportStatus
   */
  updatedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalImportStatus
   */
  completedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalImportStatus
   */
  error?: string;
}

export function ExternalImportStatusFromJSON(json: any): ExternalImportStatus {
  return {
    id: json["id"],
    importType: json["import_type"],
    projectId: !exists(json, "project_id") ? undefined : json["project_id"],
    sourceProject: !exists(json, "source_project")
      ? undefined
      : json["source_project"],
    status: json["status"],
    stage: !exists(json, "stage") ? undefined : json["stage"],
    progress: !exists(json, "progress")
      ? undefined
      : ExternalImportProgressFromJSON(json["progress"]),
    stats: !exists(json, "stats")
      ? undefined
      : ExternalImportStatsFromJSON(json["stats"]),
    throttle: !exists(json, "throttle")
      ? undefined
      : ExternalImportThrottleFromJSON(json["throttle"]),
    lastActivity: !exists(json, "last_activity")
      ? undefined
      : json["last_activity"],
    startedAt: !exists(json, "started_at") ? undefined : json["started_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
    completedAt: !exists(json, "completed_at")
      ? undefined
      : json["completed_at"],
    error: !exists(json, "error") ? undefined : json["error"],
  };
}

export function ExternalImportStatusToJSON(value?: ExternalImportStatus): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    import_type: value.importType,
    project_id: value.projectId,
    source_project: value.sourceProject,
    status: value.status,
    stage: value.stage,
    progress: ExternalImportProgressToJSON(value.progress),
    stats: ExternalImportStatsToJSON(value.stats),
    throttle: ExternalImportThrottleToJSON(value.throttle),
    last_activity: value.lastActivity,
    started_at: value.startedAt,
    updated_at: value.updatedAt,
    completed_at: value.completedAt,
    error: value.error,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ExternalImportStatusStatusEnum {
  Pending = "pending",
  Authenticating = "authenticating",
  FetchingRepos = "fetching_repos",
  FetchingCases = "fetching_cases",
  FetchingPlans = "fetching_plans",
  Writing = "writing",
  Done = "done",
  Failed = "failed",
  Cancelled = "cancelled",
}
